import React from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

export const DashboardSubTypography = ({ text = "텍스트 없음" }) => {
  return (
    <Typography
      textAlign="left"
      variant="h3"
      component="div"
      fontWeight={500}
      sx={{ pl: 1 }}
    >
      {text}
    </Typography>
  );
};

DashboardSubTypography.propTypes = {
  text: PropTypes.string,
};
